// Vidéo du hero : la lecture automatique est déclarée en HTML (autoplay muted
// loop). Ce module ne fait qu'une chose — la neutraliser pour les utilisateurs
// qui ont demandé à réduire les animations, ce que le HTML seul ne permet pas.
(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    var video = document.querySelector(".hero__video");
    if (!video) return;

    var reduced = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (!reduced.matches) return;

    // Retirer l'attribut ne suffit pas si la lecture a déjà démarré.
    video.removeAttribute("autoplay");
    video.pause();
  });
})();
